import { Button } from "components/ui/button";
import { cn } from "lib/utils";
import { ReactNode } from "react";

type ConsolidatedSectionHeaderProps = {
  icon: ReactNode;
  title: string;
  onViewMore: () => void;
  className?: string;
};

const ConsolidatedSectionHeader = ({
  icon,
  title,
  onViewMore,
  className,
}: ConsolidatedSectionHeaderProps) => (
  <div
    className={cn(
      "mb-6 flex items-center justify-between gap-4",
      className,
    )}
  >
    <div className="flex items-center gap-2">
      {icon}
      <h2 className="body-16-semibold">{title}</h2>
    </div>
    <Button variant="link" className="h-auto p-0" onClick={onViewMore}>
      View more
    </Button>
  </div>
);

export default ConsolidatedSectionHeader;
